import Card from "../foundational/Card";
import Button from "../foundational/Button";

// La card protagonista del TENS en su inicio (paso 2 de la interfaz por
// experiencia). Sebastián eligió la maqueta "Panorama" el 2026-10-16
// (docs/pitch/preview-turno-tens/): cuántos pacientes, a qué hora termina y lo
// último que registró, con UN botón para seguir. Va en el mismo lugar del DOM
// que EL MOMENTO del enfermero y que MomentoEstudiante.
//
// Lee `resumenTurnoTens` (lib/tensResumen.js): solo catálogos y números, jamás
// texto libre del paciente. Es navegación: cero háptica. Sin turno empezado
// ofrece empezarlo, sin reprochar nada.
const Ojo = ({ children }) => (
  <p className="flex items-center gap-2 text-micro uppercase tracking-wide font-semibold font-sans text-accent mb-2.5">
    <span aria-hidden="true" className="w-1.5 h-1.5 rounded-full bg-accent flex-shrink-0" />
    {children}
  </p>
);

export default function MomentoTens({ resumen, onAbrirTurno }) {
  if (!resumen) {
    return (
      <section aria-label="Tu momento" className="mt-6">
        <Card variant="protagonista" padding="lg">
          <Ojo>Tu turno</Ojo>
          <h2 className="text-h2 font-serif text-ink leading-snug">Empieza tu turno</h2>
          <p className="mt-2 text-body text-ink-subtle font-sans leading-relaxed">
            Elige tus camas de hoy y registra los cuidados desde la fila de cada paciente.
          </p>
          <div className="mt-4">
            <Button size="lg" className="min-h-[44px]" onClick={onAbrirTurno}>
              Empezar mi turno
            </Button>
          </div>
        </Card>
      </section>
    );
  }

  const { nPacientes, turno, finHora, servicio, ultimo } = resumen;
  const ojo = [servicio, turno].filter(Boolean).join(" · ") || "Tu turno";
  return (
    <section aria-label="Tu momento" className="mt-6">
      <Card variant="protagonista" padding="lg">
        <Ojo>{ojo}</Ojo>
        <h2 className="text-h2 font-serif text-ink leading-snug">
          Tu turno, {nPacientes} {nPacientes === 1 ? "paciente" : "pacientes"}
        </h2>
        {finHora && (
          <p className="mt-1 text-small text-ink-muted font-sans">
            Termina a las <span className="font-cifras text-ink">{finHora}</span>
          </p>
        )}
        {ultimo && (
          <div className="mt-4 rounded-tk-sm border border-edge bg-surface px-3 py-2.5">
            <p className="text-micro uppercase tracking-wide font-semibold font-sans text-ink-muted">Lo último que registraste</p>
            <p className="mt-0.5 text-small text-ink font-sans">
              Cama {ultimo.cama} · {ultimo.que} · <span className="font-cifras">{ultimo.hora}</span>
            </p>
          </div>
        )}
        <div className="mt-4">
          <Button size="lg" className="min-h-[44px]" onClick={onAbrirTurno}>
            Seguir con mi turno
          </Button>
        </div>
      </Card>
    </section>
  );
}
